import { useContext } from "react";
import { BuySubscriptionContext } from "features/settings/Subscription/BuySubscription.context.tsx";
import { getPlanPrice } from "@shared/features/settings/subscription/utils";
import { round } from "@shared/utils/numbers";
import { SubscriptionDuration } from "@shared/types";

export const useGetPrices = (includePromoCode?: boolean) => {
  const {
    plan,
    duration,
    promoCodePrices,
    showUpgradePrices,
    isCryptoPayment,
    upgradePrices,
  } = useContext(BuySubscriptionContext)!;

  const promoCodePriceData = includePromoCode
    ? promoCodePrices?.[duration as SubscriptionDuration]
    : undefined;
  const initialPlanPrice = showUpgradePrices
    ? upgradePrices?.upgrade_setup_price
    : getPlanPrice(plan?.[duration as SubscriptionDuration]);
  const promoCodePlanPrice = showUpgradePrices
    ? undefined
    : promoCodePriceData?.recurring_price;
  const planPrice = promoCodePlanPrice ?? initialPlanPrice;
  const extraFee = round(isCryptoPayment ? 0.05 * planPrice : 0, 2);
  const totalPrice = round(planPrice + extraFee, 2);

  return { planPrice, extraFee, totalPrice };
};
